<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" ></wt-form-table>
  </div>
</template>

<script>
export default {
  name: 'SiteIndex',
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_SITE_ORGANIZATION',
        formComponent: {
          list: { type: 'default', value: '/modules/org/orgList' },
          delete: { type: 'default', value: '/modules/org/orgDelete' },
          add: { type: 'component', componentName: 'SiteOrganizationEditPage', detailData: {}},
          edit: { type: 'component', componentName: 'SiteOrganizationEditPage', detailData: {}},
          view: { type: 'component', componentName: 'SiteOrganizationViewPage', detailData: {}}
        },
        formInputsData: [
          { name: '机构层级',
            key: 'level',
            value: '',
            type: 'select',
            data: [
              { label: '总公司', value: 1 },
              { label: '分公司', value: 2 },
              { label: '项目部', value: 3 }
            ] },
          { name: '机构名称', key: 'name', value: '', type: 'text' }],
        formButtonsData: [{ name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false, permission: 'ADD' },
          { name: '导入', key: 'IMPORT', action: 'IMPORT', hidden: false, type: 'IMPORT', url: window.wtConst.BASE_API + '/modules/org/orgListImport', permission: 'IMPORT' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', className: 'danger', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '物业总公司', key: 'name1', type: 'text' },
          { name: '物业分公司', key: 'name2', type: 'text' },
          { name: '项目部', key: 'name3', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' },
          { name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true }
      }
    }
  },
  methods: {
    onButtonAction(data) {}
  }
}
</script>
